import { a, C } from "../CommonStringUtils-1580a6f6.js";
import "lodash";
import "moment";
export {
  a as CommonUtils,
  C as CommonUtilsInstance
};
//# sourceMappingURL=CommonUtils.js.map
